import { render, staticRenderFns } from "./bankflow.vue?vue&type=template&id=55bcc9da&scoped=true&"
import script from "./bankflow.vue?vue&type=script&lang=js&"
export * from "./bankflow.vue?vue&type=script&lang=js&"
import style0 from "./bankflow.vue?vue&type=style&index=0&id=55bcc9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bcc9da",
  null
  
)

export default component.exports